<!-- ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- -->
<app-alert *ngIf="sessionExpired" [type]="'warning-info'" [message]="sessionExpiredMessage"
    [display]="true"></app-alert>
<main>
    <router-outlet></router-outlet>
</main>

<div [hidden]="!show" id="loader">
    <div class="loader-wrapper">
        <div class="hid-loader-overlay">
            <div class="hid-loader hid-loader__large hid-loader__large--thin-border"></div>
        </div>
    </div>
</div>

<app-notification *ngIf="notification" [type]="notification.type" [title]="notification.title"
    [subtitle]="notification.subtitle">
</app-notification>